import { Component, Input, OnInit } from '@angular/core'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'account-page',
	templateUrl: './Page.Component.html',
	imports: [NgStyle],
})
export class PageComponent implements OnInit {
	@Input() public title: string

	@Input() public subtitle: string

	public ngOnInit(): void {
		if (this.title) {
			document.title = this.title
		}
	}
}
